import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { animated } from "react-spring";

export const panelStyles = (key: number) =>
  makeStyles(() => ({
    title: {
      fontFamily: "Manrope",
      fontWeight: 700,
      fontSize: "16px",
      lineHeight: "22px",
      color: "#465869",
    },
    panel: {
      width: "100%",
      textAlign: "left",
    },
    panelContent: {
      border: "1px solid #E4E7EC",
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    panelHeading: {
      background: "#FCFCFD",
      border: "1px solid #E4E7EC",
      borderTopRightRadius: key === 0 ? "8px" : "0px",
      borderTopLeftRadius: key === 0 ? "8px" : "0px",
      color: "#667085",
      padding: "11px 32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      cursor: "pointer",
      "& span": {
        fontFamily: "Manrope",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 800,
        lineHeight: "normal",
        color: colors.gray500,
      },
    },
    noTasksText: {
      fontFamily: "Manrope",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: "0.5px",
      color: colors.gray400,
    },
  }));

export const PanelContent = styled(animated.div)(() => ({
  overflow: "hidden",
}));

export const PanelCard = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "isAssigned";
  },
})<{ isAssigned?: boolean }>(({ isAssigned }) => {
  return {
    display: "flex",
    padding: "16px",
    fontStyle: "normal",
    borderRadius: "12px",
    border: `1px ${isAssigned ? "solid" : "dashed"} ${colors.gray200}`,
    cursor: "pointer",
    gap: "16px",
  };
});

export const PanelTitle = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "isVip" && propName !== "isAssigned";
  },
})<{ isVip?: boolean; isAssigned?: boolean }>(({ isVip, isAssigned }) => {
  let textColor: string;

  if (isVip) {
    textColor = isAssigned ? colors.warning500 : colors.gray600;
  } else {
    textColor = isAssigned ? colors.brandBlue500 : colors.gray600;
  }

  return {
    fontFamily: "Manrope",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: textColor,

    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  };
});

export const PanelText = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "isPlaceholder";
  },
})<{ isPlaceholder?: boolean }>(({ isPlaceholder }) => {
  return {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0.25px",

    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",

    color: isPlaceholder ? colors.gray400 : colors.gray600,
  };
});

export const DateRange = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  columnGap: "8px",
  padding: "4px 8px",
  border: `1px solid ${colors.gray200}`,
  width: "fit-content",
  borderRadius: "100px",

  backgroundColor: colors.gray50,
  "& span": {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0.5px",
  },
});
